const usFormatPhoneNumber = (number: string | null | undefined): string => {
  if (!number) return number ?? '';
  const digits = number.replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (local.length !== 10) return number;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
};

export default usFormatPhoneNumber;
